<template>
  <transition name="modal">
    <div
      v-if="showing"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-8"
      role="dialog"
      aria-modal="true"
    >
      <div class="absolute inset-0 bg-black/75 backdrop-blur-sm" @click="close" />

      <div
        ref="dialog"
        class="relative z-10 w-full bg-white shadow-2xl transition-all duration-300"
        :class="isFullscreen ? 'rounded-none max-w-none h-screen overflow-y-auto' : 'rounded-2xl max-w-4xl overflow-hidden'"
      >
        <!-- Fullscreen toggle -->
        <button
          @click="toggleFullscreen"
          :aria-label="isFullscreen ? 'Vollbild beenden' : 'Vollbild'"
          class="absolute top-3 right-14 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-black/40 hover:bg-black/60 text-white transition-colors duration-200"
        >
          <svg v-if="!isFullscreen" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 8V6a2 2 0 012-2h2M4 16v2a2 2 0 002 2h2m8-16h2a2 2 0 012 2v2m0 8v2a2 2 0 01-2 2h-2" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <!-- Close -->
        <button
          @click="close"
          aria-label="Schliessen"
          class="absolute top-3 right-3 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-black/40 hover:bg-black/60 text-white transition-colors duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    showing: {
      required: true,
      default: false
    }
  },
  emits: ['close'],
  data() {
    return { isFullscreen: false }
  },
  watch: {
    showing(val) {
      if (!val && this.isFullscreen) this.isFullscreen = false
    }
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown)
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown)
    document.removeEventListener('fullscreenchange', this.onFullscreenChange)
  },
  methods: {
    close() {
      if (this.isFullscreen) document.exitFullscreen()
      this.$emit('close')
    },
    onKeydown(e) {
      if (e.key === 'Escape' && this.showing) this.close()
    },
    toggleFullscreen() {
      if (!this.isFullscreen) {
        this.$refs.dialog.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    },
    onFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement
    }
  }
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.25s ease;
}
.modal-enter-active .relative,
.modal-leave-active .relative {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
.modal-enter-from .relative {
  transform: translateY(16px);
  opacity: 0;
}
</style>
